import { Controller } from "@hotwired/stimulus"
import { Editor } from "@tiptap/core"
import StarterKit from "@tiptap/starter-kit"
import Placeholder from "@tiptap/extension-placeholder"
import TaskItem from "@tiptap/extension-task-item"
import TaskList from "@tiptap/extension-task-list"

export default class extends Controller {
  static targets = ["editor", "jsonInput", "textInput", "toolbar"]
  static values = {
    editable: { type: Boolean, default: true },
    placeholder: String
  }

  connect() {
    this.editor = new Editor({
      element: this.editorTarget,
      editable: this.editableValue,
      content: this.content(),
      extensions: [
        StarterKit.configure({
          heading: { levels: [2, 3] }
        }),
        Placeholder.configure({
          placeholder: this.placeholderValue
        }),
        TaskList,
        TaskItem.configure({
          nested: true
        })
      ],
      onUpdate: ({ editor }) => {
        this.jsonInputTarget.value = JSON.stringify(editor.getJSON())
        this.textInputTarget.value = editor.getText({ blockSeparator: "\n" })
        this.jsonInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  }

  disconnect() {
    this.editor?.destroy()
  }

  content() {
    try {
      return JSON.parse(this.jsonInputTarget.value)
    } catch (_error) {
      return { type: "doc", content: [{ type: "paragraph" }] }
    }
  }

  toggleToolbar() {
    if (!this.hasToolbarTarget) return
    this.toolbarTarget.hidden = !this.toolbarTarget.hidden
  }

  heading() {
    this.editor.chain().focus().toggleHeading({ level: 2 }).run()
  }

  bulletList() {
    this.editor.chain().focus().toggleBulletList().run()
  }

  orderedList() {
    this.editor.chain().focus().toggleOrderedList().run()
  }

  bold() {
    this.editor.chain().focus().toggleBold().run()
  }

  italic() {
    this.editor.chain().focus().toggleItalic().run()
  }

  blockquote() {
    this.editor.chain().focus().toggleBlockquote().run()
  }

  taskList() {
    this.editor.chain().focus().toggleTaskList().run()
  }
}
